<script setup lang="ts">
import type { RiskLevel } from "@ca/types/risk";
import type { Nullish } from "@ca/types/util";

import { computed } from "vue";

import { riskLevelToColor } from "@ca/risk/flight";

const props = withDefaults(defineProps<{
	risk: Nullish<RiskLevel>;
	score?: number;
	size?: "sm" | "md";
}>(), { score: undefined, size: "md" });

const label = computed(() => {
	if (props.score != null) {
		return `${Math.round(props.score)}/100`;
	}
	if (!props.risk) {
		return "Unknown Risk";
	}
	return `${props.risk} Risk`;
});

const color = computed(() => {
	return riskLevelToColor(props.risk).bg;
});
</script>

<template>
  <span
    class="inline-flex items-center bg-brand-500 py-1 rounded-sm w-fit"
    :class="size === 'sm' ? 'gap-1.5 px-2 text-xs leading-4' : 'gap-2 px-3'"
  >
    <span
      :class="[color, size === 'sm' ? 'size-1' : 'size-1.5']"
      class="rounded-full"
    />
    <span class="uppercase text-white font-cta">
      {{ label }}
    </span>
  </span>
</template>
